import React from "react";

const CreateThread = () => {
  return <div>CreateTemplate</div>;
};

export default CreateThread;
